export default {
  inspectorManagers: () => `/inspector/managers`,
  inspectorDailySummary: (inspectorNumber, payPeriodId) => `/inspectors/${inspectorNumber}/time-card/pay-period/${payPeriodId}/daily-summary`,
  inspectorCaseTime: (inspectorNumber, payPeriodId) => `/inspectors/${inspectorNumber}/time-card/pay-period/${payPeriodId}/case-time`,
  inspectorCaseMiles: (inspectorNumber, payPeriodId) => `/inspectors/${inspectorNumber}/time-card/pay-period/${payPeriodId}/miles-summary`,
  updateInspectorCaseTime: () => `/inspectors/time-card/case-time`,
  updateInspectorCaseMiles: () => `/inspectors/time-card/case-miles`,
};
